import { CountryCode, CountryFlag, IconSizes } from '@dixa/lib-shared-habla';

import styles from './phoneNumberCountryFlag.module.scss';

type PhoneNumberCountryFlagProps = {
  /** The country of the phone number, in lower case. */
  countryCode?: CountryCode;
  /** The size of the flag. */
  size?: IconSizes;
};

/**
 * A component that returns the flag of the country of a phone number. Without
 * a country the flag is transparent, so the flag still takes up its space.
 */
export const PhoneNumberCountryFlag = ({
  countryCode,
  size = 20,
}: PhoneNumberCountryFlagProps): JSX.Element => {
  return (
    <CountryFlag
      className={countryCode ? undefined : styles.transparent}
      countryCode={countryCode ?? 'dk'}
      size={size}
    />
  );
};
